export interface DayPromo {
  day: string;
  dayNumber: number;
  title: string;
  subtitle: string;
  description: string;
  offers: string[];
  buttonText: string;
  buttonAction: string;
  bgColor: string;
  textColor: string;
  icon: string;
  image: string;
  timing?: string;
  ageRestriction?: string;
}

export const weeklyPromos: DayPromo[] = [
  {
    day: 'Tuesday',
    dayNumber: 2,
    title: 'Vintage Vibes',
    subtitle: 'Six Fields Draft Beer Tower',
    description: 'Experience classic vibes with our signature beer tower special',
    offers: [
      'Six Fields Draft Beer Tower - Buy 1.5L, Get 0.5L Free',
      'Retro Music Playlist',
      'Vintage Decor & Ambiance',
      'Complimentary Snacks'
    ],
    buttonText: 'Order Beer Tower',
    buttonAction: '/menu',
    bgColor: '#2d1810',
    textColor: '#D4AF37',
    icon: '🍺',
    image: '/images/bg-img/bar.jpg',
    timing: '6 PM - 1:30 AM',
    ageRestriction: '21+'
  },
  {
    day: 'Wednesday',
    dayNumber: 3,
    title: 'Sip & Slay',
    subtitle: "Ladies' Special Night",
    description: 'Make your own cocktail experience - Ladies get special pricing',
    offers: [
      'Ladies Entry: Free',
      'Make Your Own Cocktail Workshop',
      'Complimentary First Drink',
      'DJ & Dance Floor',
      'Special Pricing on All Drinks'
    ],
    buttonText: 'Book for Ladies Night',
    buttonAction: '/enquiry',
    bgColor: '#4a0e4e',
    textColor: '#FF69B4',
    icon: '👑',
    image: '/images/bg-img/lounge.jpg',
    timing: '6 PM - 1:30 AM',
    ageRestriction: '18+'
  },
  {
    day: 'Thursday',
    dayNumber: 4,
    title: 'Toast & Tequila',
    subtitle: 'Latin & Afro Lounge Vibes',
    description: 'Tequila night with Latin and Afro beats - Get 1+1 on selected brands',
    offers: [
      'Tequila 1+1 (Selected Premium Brands)',
      'Latin & Afro Music',
      'Themed Decor',
      'Complimentary Lime & Salt',
      'Dance Floor Open'
    ],
    buttonText: 'Reserve Spot',
    buttonAction: '/enquiry',
    bgColor: '#8B4513',
    textColor: '#FFD700',
    icon: '🌮',
    image: '/images/bg-img/club.jpg',
    timing: '6 PM - 1:30 AM',
    ageRestriction: '21+'
  },
  {
    day: 'Friday',
    dayNumber: 5,
    title: 'Patiala Rave',
    subtitle: 'Punjabi Bass & Tandoori Nights',
    description: 'Punjabi music, tandoori food, and drinks - Ek Badi Peg Pe Ek Chota Peg Free',
    offers: [
      'Ek Badi Peg Pe Ek Chota Peg Free (Selected Brands)',
      'Punjabi Bass Music',
      'Tandoori Special Menu',
      'VIP Tables Available',
      'Live DJ Performance'
    ],
    buttonText: 'Book VIP Table',
    buttonAction: '/enquiry',
    bgColor: '#FF6B35',
    textColor: '#FFFFFF',
    icon: '🎶',
    image: '/images/bg-img/party.jpg',
    timing: '6 PM - 1:30 AM',
    ageRestriction: '21+'
  },
  {
    day: 'Saturday',
    dayNumber: 6,
    title: 'After Dark',
    subtitle: 'DJ • Models • Commercial Hits',
    description: 'The hottest night of the week - VIP tables, premium drinks, and top DJs',
    offers: [
      '5 + 1 All Beers (Buy 5, Get 1 Free)',
      '5 + 2 Shots on Selected Brands',
      'VIP Tables Available',
      'Professional DJ',
      'Models & Entertainment',
      'Premium Sound System'
    ],
    buttonText: 'Book VIP Now',
    buttonAction: '/enquiry',
    bgColor: '#1a1a2e',
    textColor: '#00D4FF',
    icon: '🌙',
    image: '/images/bg-img/club.jpg',
    timing: '6 PM - 1:30 AM',
    ageRestriction: '21+'
  },
  {
    day: 'Sunday',
    dayNumber: 0,
    title: 'Sundae Socialz',
    subtitle: 'Family & Friends Day',
    description: 'Relax with family and friends - Kids menu on the house',
    offers: [
      'Kids Menu - On The House',
      'Family Packages Available',
      'Casual Dress Code',
      'Complimentary Appetizers',
      'Live Acoustic Music',
      'Special Family Pricing'
    ],
    buttonText: 'Reserve Family Table',
    buttonAction: '/enquiry',
    bgColor: '#2d5016',
    textColor: '#90EE90',
    icon: '👨👩👧👦',
    image: '/images/bg-img/lounge.jpg',
    timing: '6 PM - 1:30 AM',
    ageRestriction: 'All Ages'
  }
];

export const getTodayPromo = (): DayPromo | null => {
  const today = new Date().getDay();
  return weeklyPromos.find(promo => promo.dayNumber === today) || null;
};

export const getPromoByDay = (dayNumber: number): DayPromo | null => {
  return weeklyPromos.find(promo => promo.dayNumber === dayNumber) || null;
};
